/*
 * 36氪 - 热榜（服务端路由）
 */
export async function fetch36krHot() {
  const res = await fetch('/server-api/36kr')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
